import { request } from '@/utils/request'

const API = {
    // 组织架构相关
    orgEditJoinProject: '/sys/org/editJoinProject',
    orgDelete: '/sys/org/delOrg',
    orgUpdate: '/sys/org/editOrg',
    orgFullOrg: '/sys/org/fullOrg',
    orgInfo: '/sys/org/info',
    orgQueryJoinProject: '/sys/org/queryJoinProject',
    orgSetDeptManager: '/sys/org/setDeptManager',
    userFields: '/user/fields', //用户列表获取查询条件
    userAdd: '/user/add', //新增、编辑用户
    userDelete: '/user/delete', //删除用户
    userInfo: '/user/info', //获取用户详情
    userInitPage: '/user/initPage', //初始化组织
    userResetPassword: '/user/resetPassword', //重置密码
    userResetPwd: '/user/resetPwd', //重置密码
    userSelectUserPageList: '/user/selectUserPageList', //选择用户列表
}

export const orgApi = {
    // 组织架构相关
    getEditJoinProject(params) {
        return request.post(API.orgEditJoinProject, params)
    },
    getDelete(orgId) {
        return request.post(API.orgDelete, orgId)
    },
    getUpdate(params) {
        return request.post(API.orgUpdate, params)
    },
    getFullOrg(params) {
        return request.post(API.orgFullOrg, params)
    },
    getInfo(params) {
        return request.post(API.orgInfo, params)
    },
    getQueryJoinProject(params) {
        return request.post(API.orgQueryJoinProject, params)
    },
    getSetDeptManager(orgId) {
        return request.post(API.orgSetDeptManager, orgId)
    },
    // 用户相关
    getUserFields(params) {
        return request.get(API.userFields, params)
    },
    getUserAdd(params) {
        return request.post(API.userAdd, params)
    },
    getUserDelete(userId) {
        return request.delete(API.userDelete + '?userId=' + userId)
    },
    getUserInfo(params) {
        return request.post(API.userInfo, params)
    },
    getUserInitPage(params) {
        return request.post(API.userInitPage, params)
    },
    getUserResetPassword(params) {
        return request.post(API.userResetPassword, params)
    },
    getUserResetPwd(params) {
        return request.post(API.userResetPwd, params)
    },
    getUserSelectUserPageList(params) {
        return request.post(API.userSelectUserPageList, params)
    },
}